import { getAnonId, getHandle } from "@karrtopelka/game-kit";
import type { CashResult } from "../store.js";

/** Same-origin mines API. Every reveal is server-confirmed (D1 round ledger). */

export async function startRound(): Promise<string | null> {
  try {
    const res = await fetch("/api/mines/start", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ anonId: getAnonId() }),
    });
    if (!res.ok) return null;
    const { roundId } = (await res.json()) as { roundId: string };
    return roundId;
  } catch {
    return null;
  }
}

export type RevealResult =
  | { hit: true; mines: number[] }
  | { hit: false; mult: number; count: number; cleared: boolean }
  | null;

export async function revealTile(roundId: string, pick: number): Promise<RevealResult> {
  try {
    const res = await fetch("/api/mines/reveal", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ anonId: getAnonId(), roundId, pick }),
    });
    if (!res.ok) return null;
    return (await res.json()) as RevealResult;
  } catch {
    return null;
  }
}

export async function cashoutRound(roundId: string): Promise<CashResult | null> {
  const handle = getHandle();
  if (!handle) return null; // caller collects a handle first
  try {
    const res = await fetch("/api/mines/cashout", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ anonId: getAnonId(), handle, roundId }),
    });
    if (!res.ok) return null;
    return (await res.json()) as CashResult;
  } catch {
    return null;
  }
}
